import { style } from 'typestyle'
export const z5 = style({ zIndex: 5 })
